export function refreshCSRFToken() {
    return fetch(route("csrf.token"), {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    })
        .then((response) => response.json())
        .then((data) => {
            // Update meta tag
            document
                .querySelector('meta[name="csrf-token"]')
                .setAttribute("content", data.csrf_token);

            // Update axios default header if using axios
            if (window.axios) {
                window.axios.defaults.headers.common["X-CSRF-TOKEN"] =
                    data.csrf_token;
            }

            return data.csrf_token;
        });
}

// Set up periodic refresh (every 90 minutes)
setInterval(refreshCSRFToken, 90 * 60 * 1000);
